export const satisfaction = {
  firstNoticeLoss: '0',
  processEstimation: '0',
  repairProcess: '0.5',
  claimsServicing: '2',
  rentalExperience: '3.5',
  settlement: '5'
};
